export const COLUMN_CONFIG = {
  stores: [
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'external_id', headerName: 'External ID', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },
    { field: 'channel', headerName: 'Channel', width: 150 },

    { field: 'last_tx', headerName: 'Last Transaction', width: 150 },
    { field: 'status', headerName: 'Status', width: 150 },

    { field: 'issue_reason', headerName: 'Issue Reason', width: 150 },

    { field: 'live_date', headerName: 'Live Date', width: 200 },

    { field: 'dead_date', headerName: 'Decommissioned Date', width: 300 },

    { field: 'planogram', headerName: 'Current Planogram', width: 150 },
    { field: 'country', headerName: 'Country', width: 150 },
    { field: 'time_zone', headerName: 'Time Zone', width: 150 },
  ],
  users: [
    { field: 'id', headerName: 'User ID', width: 150 },
    { field: 'displayName', headerName: 'Display Name', width: 200 },
    { field: 'company', headerName: 'Company', width: 150 },
    { field: 'email', headerName: 'Email', width: 250 },
    { field: 'userType', headerName: 'User Type', width: 100 },
  ],
  Transactions: [
    {
      field: 'transaction_timestamp',
      headerName: 'Transaction Timestamp(UTC)',
      width: 250,
      valueGetter: (params) => {
        const timestamp = params;
        if (timestamp) {
          const date = new Date(timestamp);
          // Format the date as needed
          return date.toISOString().slice(0, 16).replace("T", " ")
        }
        return '-';
      },
    },
    {
      field: 'store_local_transaction_timestamp',
      headerName: 'Store Local Timestamp',
      width: 250,
      valueGetter: (params) => {
        const timestamp = params; // Ensure `params` has the correct timestamp value
        if (timestamp) {
          // Slice to remove seconds and milliseconds
          return timestamp.slice(0, 16);
        }
        return '-';
      },
    },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },
    { field: 'session_id', headerName: 'Session ID', width: 250 },
    { field: 'transaction_id', headerName: 'Transaction ID', width: 250 },
    {
      field: 'payment_gateway_transaction_id',
      headerName: 'Payment Gateway Tx ID',
      width: 250,
    },
    {
      field: 'sent_to_payment_gateway',
      headerName: 'Sent to Payment Gateway',
      width: 250,
    },

    { field: 'approval_code', headerName: 'Approval Code', width: 150 },
    { field: 'machine_type', headerName: 'Store Type', width: 100 },
    { field: 'city', headerName: 'City', width: 150 },
    { field: 'state', headerName: 'State', width: 100 },
    { field: 'postal_code', headerName: 'Postal Code', width: 100 },
    { field: 'country_code', headerName: 'Country Code', width: 100 },

    { field: 'customer_email', headerName: 'Customer Email', width: 250 },
    { field: 'customer_phone', headerName: 'Customer Phone', width: 200 },

    { field: 'payment_method', headerName: 'Payment Method', width: 150 },
    { field: 'card_type', headerName: 'Card Type', width: 100 },
    { field: 'currency_code', headerName: 'Currency Code', width: 100 },

    { field: 'ordered_qty', headerName: 'Ordered Qty', width: 150 },
    {
      field: 'delivered_qty',
      headerName: 'Delivered Qty',
      width: 150,
    },

    { field: 'cart_subtotal', headerName: 'Cart Subtotal', width: 150 },
    { field: 'cart_tax', headerName: 'Cart Tax', width: 150 },
    { field: 'cart_discount', headerName: 'Cart Discount', width: 150 },
    { field: 'charge_amount', headerName: 'Charged Amount', width: 150 },
  ],
  'Transaction Details': [
    {
      field: 'transaction_timestamp',
      headerName: 'Transaction Timestamp(UTC)',
      width: 200,
      valueGetter: (params) => {
        const timestamp = params;
        if (timestamp) {
          const date = new Date(timestamp);
          // Format the date as needed
          return date.toISOString().slice(0, 16).replace("T", " ")
        }
        return '-';
      },
    },
    {
      field: 'store_local_transaction_timestamp',
      headerName: 'Store Local Timestamp',
      width: 200,
      valueGetter: (params) => {
        const timestamp = params; // Ensure `params` has the correct timestamp value
        if (timestamp) {
          // Slice to remove seconds and milliseconds
          return timestamp.slice(0, 16);
        }
        return '-';
      },
    },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },
    { field: 'session_id', headerName: 'Session ID', width: 250 },
    { field: 'transaction_id', headerName: 'Transaction ID', width: 250 },
    {
      field: 'payment_gateway_transaction_id',
      headerName: 'Payment Gateway Tx ID',
      width: 250,
    },

    { field: 'approval_code', headerName: 'Approval Code', width: 150 },
    { field: 'machine_type', headerName: 'Store Type', width: 100 },
    { field: 'payment_method', headerName: 'Payment Method', width: 150 },

    { field: 'product_upc', headerName: 'Product UPC', width: 150 },
    { field: 'product_sku', headerName: 'Product SKU', width: 150 },
    {
      field: 'product_alternate_skus',
      headerName: 'Alternate SKU',
      width: 150,
    },
    { field: 'product_name', headerName: 'Product Name', width: 300 },

    { field: 'currency_code', headerName: 'Currency Code', width: 100 },
    { field: 'unit_price', headerName: 'Unit Price', width: 150 },
    { field: 'unit_tax', headerName: 'Unit Tax', width: 150 },
    { field: 'unit_discount', headerName: 'Unit Discount', width: 150 },
    { field: 'ordered_qty', headerName: 'Ordered Quantity', width: 150 },
    {
      field: 'delivered_qty',
      headerName: 'Delivered Quantity',
      width: 150,
    },
    { field: 'cart_subtotal', headerName: 'Cart Subtotal', width: 150 },
    { field: 'cart_tax', headerName: 'Cart Tax', width: 150 },
    { field: 'cart_discount', headerName: 'Cart Discount', width: 150 },
    { field: 'charge_amount', headerName: 'Charged Amount', width: 150 },
  ],
  Sales: [
    { field: 'date', headerName: 'Date', width: 150 },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },

    { field: 'product_sku', headerName: 'Product SKU', width: 150 },
    {
      field: 'product_alternate_skus',
      headerName: 'Alternate SKUs',
      width: 200,
    },
    { field: 'product_upc', headerName: 'Product UPC', width: 150 },
    { field: 'product_name', headerName: 'Product Name', width: 300 },

    { field: 'currency_code', headerName: 'Currency Code', width: 100 },
    { field: 'sale_amount', headerName: 'Sale Amount', width: 150 },
    { field: 'tax_amount', headerName: 'Tax Amount', width: 150 },
    { field: 'ordered_qty', headerName: 'Ordered Quantity', width: 150 },
    { field: 'units_sold', headerName: 'Units Sold', width: 150 },

    // { field: 'date_local', headerName: 'Local Date', width: 150 },
    // { field: 'date_utc', headerName: 'UTC Date', width: 150 },
  ],
  'Inventory Events': [
    { field: 'event_timestamp',
      headerName: 'Timestamp(UTC)',
      width: 200,
      valueGetter: (params) => {
        const timestamp = params; // Ensure `params` has the correct timestamp value
        if (timestamp) {
          // Slice to remove seconds and milliseconds
          return timestamp.slice(0, 16);
        }
        return '-';
      },
     },
    {
      field: 'store_local_event_timestamp',
      headerName: 'Store Local Timestamp',
      width: 200,
      valueGetter: (params) => {
        const timestamp = params; // Ensure `params` has the correct timestamp value
        if (timestamp) {
          // Slice to remove seconds and milliseconds
          return timestamp.slice(0, 16);
        }
        return '-';
      },
    },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },
    { field: 'transaction_id', headerName: 'Transaction ID', width: 250 },

    { field: 'technician_id', headerName: 'Technician ID', width: 200 },
    { field: 'event_reason', headerName: 'Event Reason', width: 200 },
    { field: 'transfer_number', headerName: 'Transfer Order', width: 200 },

    { field: 'product_sku', headerName: 'Product SKU', width: 150 },
    {
      field: 'product_alternate_skus',
      headerName: 'Alternate SKU',
      width: 150,
    },
    { field: 'product_upc', headerName: 'Product UPC', width: 150 },
    { field: 'product_name', headerName: 'Product Name', width: 300 },
    { field: 'dispenser', headerName: 'Dispenser', width: 200 },

    { field: 'stock_change', headerName: 'Stock Change', width: 150 },
    { field: 'new_level', headerName: 'New Level', width: 150 },

    // Optional fields
    // { field: 'tracking_number', headerName: 'Tracking Number', width: 200 },
    // { field: 'transfer_number', headerName: 'Transfer Number', width: 200 },
  ],
  'Inventory Snapshot': [
    { field: 'date',
      headerName: 'Date',
      width: 150,
      valueGetter: (params) => {
        const timestamp = params; // Ensure `params` has the correct timestamp value
        if (timestamp) {
          // Slice to remove seconds and milliseconds
          return timestamp.slice(0, 10);
        }
        return '-';
      },
     },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },
    { field: 'planogram', headerName: 'Planogram', width: 250 },
    // { field: 'date_local', headerName: 'Local Date', width: 150 },
    // { field: 'date_utc', headerName: 'UTC Date', width: 150 },

    { field: 'product_sku', headerName: 'Product SKU', width: 150 },
    {
      field: 'product_alternate_skus',
      headerName: 'Alternate SKUs',
      width: 200,
    },
    { field: 'product_upc', headerName: 'Product UPC', width: 150 },
    { field: 'product_name', headerName: 'Product Name', width: 300 },

    { field: 'eod_inventory', headerName: 'EOD Inventory', width: 150 },
    { field: 'in_transit', headerName: 'In Transit', width: 150 },
  ],
  'Warehouse Inventory': [
    { field: 'record_date', headerName: 'Record Date', width: 150 },
    { field: 'warehouse_name', headerName: 'Warehouse Name', width: 300 },

    { field: 'product_sku', headerName: 'Product SKU', width: 150 },
    {
      field: 'product_alternate_skus',
      headerName: 'Alternate SKUs',
      width: 200,
    },
    { field: 'product_upc', headerName: 'Product UPC', width: 150 },
    { field: 'product_name', headerName: 'Product Name', width: 300 },

    { field: 'wh_on_order', headerName: 'On Order', width: 150 },
    { field: 'wh_qty_onhand', headerName: 'On-Hand Quantity', width: 150 },
    { field: 'wh_in_transit', headerName: 'In Transit', width: 150 },
  ],
  'Network Availability': [
    { field: 'date', headerName: 'Date', width: 150 },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },

    { field: 'channel', headerName: 'Channel', width: 150 },
    { field: 'city', headerName: 'City', width: 150 },
    { field: 'state', headerName: 'State', width: 150 },

    {
      field: 'network_availability_percentage',
      headerName: 'Network Availability (%)',
      width: 200,
    },
    { field: 'operating_hours', headerName: 'Operating Hours', width: 150 },
    { field: 'uptime_hours', headerName: 'Uptime Hours', width: 150 },
    { field: 'downtime_hours', headerName: 'Downtime Hours', width: 150 },

    { field: 'live_date', headerName: 'Live Date', width: 200 },
    {
      field: 'decommissioned_date',
      headerName: 'Decommissioned Date',
      width: 200,
    },
  ],
  'Sessions Summary': [
    { field: 'date', headerName: 'Date', width: 150 },
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'location_name', headerName: 'Location Name', width: 300 },

    { field: 'sessions', headerName: 'Sessions', width: 150 },
    { field: 'transactions', headerName: 'Transactions', width: 150 },
    {
      field: 'conversion_ratio',
      headerName: 'Conversion Ratio (%)',
      width: 200,
    },
  ],
  'Marketing Survey': [
    {
      field: 'store_local_transaction_timestamp',
      headerName: 'Store Local Transaction Date',
      width: 250,
    },
    { field: 'estation_name', headerName: 'Store', width: 150 },
    // {
    //   field: 'dw_created',
    //   headerName: 'Data Warehouse Created',
    //   width: 200,
    // },
    { field: 'session_id', headerName: 'Session ID', width: 250 },
    {
      field: 'unique_transaction_id',
      headerName: 'Unique Transaction ID',
      width: 300,
    },
    { field: 'email', headerName: 'Email', width: 250 },

    // Flattening 'records' array items for better display
    {
      field: 'email_question',
      headerName: 'Email Question',
      width: 200,
      valueGetter: (params) =>
        params && params.row && params.row.records
          ? params.row.records?.find((r) => r.question_name === 'Email')
              ?.question_value || '-'
          : '-',
    },
    {
      field: 'receive_promotions',
      headerName: 'Receive Promotions',
      width: 200,
      valueGetter: (params) =>
        params && params.row && params.row.records
          ? params.row.records?.find(
              (r) => r.question_name === 'Receive Promotions',
            )?.question_value || '-'
          : '-',
    },
    {
      field: 'us_resident',
      headerName: 'Are you US Resident',
      width: 200,
      valueGetter: (params) =>
        params && params.row && params.row.records
          ? params.row.records?.find(
              (r) => r.question_name === 'Are you US Resident',
            )?.question_value || '-'
          : '-',
    },
  ],
  admin: [
    { field: 'displayName', headerName: 'User', width: 150 },
    { field: 'company', headerName: 'Company', width: 150 },
    { field: 'email', headerName: 'Email', width: 250 },
    { field: 'userType', headerName: 'User Type', width: 100 },
    { field: 'memberType', headerName: 'Member Type', width: 150 },
    { field: 'organizations', headerName: 'Organizations', width: 150 },
    { field: 'exceptions', headerName: 'Exceptions', width: 150 },
  ],
};
